import { useEffect, useState } from "react";
import { api, getDepartmentFilter, setDepartmentFilter } from "@/lib/api";
import { Building2 } from "lucide-react";

/** Selector de departamento (Todos · Español · Inglés). Solo lo ve la administración:
 *  filtra Clases, Estudiantes, Asistencia, Pagos y Reportes en toda la plataforma. */
export const DepartmentSwitcher = () => {
  const [deps, setDeps] = useState([]);
  const [value, setValue] = useState(getDepartmentFilter());

  useEffect(() => {
    api.get("/departments").then((r) => setDeps(r.data || [])).catch(() => {});
  }, []);

  if (deps.length < 2) return null;

  const cambiar = (v) => {
    setValue(v);
    setDepartmentFilter(v);
    window.location.reload();          // recarga para que todas las pantallas tomen el filtro
  };

  return (
    <label className="hidden sm:flex items-center gap-1.5 text-xs text-slate-600"
           data-testid="department-switcher">
      <Building2 className="h-4 w-4 text-slate-400" />
      <select value={value} onChange={(e) => cambiar(e.target.value)}
              className="h-8 rounded-lg border border-slate-200 bg-white px-2 text-xs font-medium text-slate-700 focus:outline-none focus:ring-2 focus:ring-brand-blue/30">
        <option value="">Todos (consolidado)</option>
        {deps.map((d) => (
          <option key={d.id} value={d.id}>{d.short_name || d.name}</option>
        ))}
      </select>
    </label>
  );
};
